<template>
  <!-- 指引 -->
  <div class="guide">
    <div class="masking"></div>
    <div class="mask-block" :style="'right:'+ (menuNameWidth + 50) +'px'"><img class="mask-img" src="../../assets/img/guide/guide3.png" alt=""></div>
    <div class="popu-block">
      <div class="block" :style="'right:'+ (menuNameWidth + 40) +'px'">
        <div class="popu-head flex-between-center">
          <div class="title">小派专服</div>
          <div class="close" @click="closeGuied">
            <img
              class="close-icon"
              src="../../assets/img/close.png"
              alt=""
            />
          </div>
        </div>
        <div class="guide-msg">遇到任何问题，小派专服在线为您解答</div>
        <div class="guide-button flex-between-center">
          <div class="step">(3/4)</div>
          <div class="flex-between-center">
            <div class="pure-button flex-center-center" @click="pure">
              上一步
            </div>
            <div class="next-button flex-center-center" @click="next">
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import api2 from "../../modules/projectA/api/user";
export default {
  props: {
    menuNameWidth:{
      type:Number,
      default:0
    }
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    ...mapMutations(["SHOW_LIB"]),
    next() {
      this.$parent.next();
    },
    pure() {
      this.$parent.pure();
    },
    async closeGuied() {
      await api2.noviceGuidanceClose().then((res) => {
        this.SHOW_LIB("-1");
      });
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
.guide {
  position: relative;
  .mask-block{
    position: absolute;
    z-index: 99999;
    top: 3px;
    .mask-img{
      width: 130px;
    }
  }
  .popu-block {
    width: 100%;
    margin: 0 auto;
    position: relative;
    .block {
      .flex-between-center {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .flex-center-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .popu-head {
        .title {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
        }
        .close {
          cursor: pointer;
          .close-icon {
            width: 12px;
            height: 12px;
            display: block;
          }
        }
      }
      .guide-msg {
        color: #333333;
        font-size: 14px;
        font-weight: 350px;
        margin-top: 10px;
      }
      .guide-button {
        position: absolute;
        bottom: 20px;
        width: 380px;
        .step {
          color: #999999;
          font-size: 16px;
        }
        .next-button {
          cursor: pointer;
          background: #2587ff;
          color: #ffffff;
          width: 78px;
          height: 28px;
          border: 1px solid #2587ff;
          margin: 0 5px;
          font-size:14px;
        }
        .next-button:hover{
          background: #6AA1FF;
        }
        .next-button:active{
          background: #0064C8;
        }
        .pure-button {
          cursor: pointer;
          color: #333333;
          width: 78px;
          height: 28px;
          border: 1px solid #c5c5c5;
          margin: 0 5px;
          font-size:14px;
          background: #ffffff;
        }
        .pure-button:hover{
          background: #E8F3FF;
          border: 1px solid #6AA1FF;
          color: #6AA1FF;
        }
        .pure-button:active{
          background: #E8F3FF;
          border: 1px solid #0064c8;
          color:#0064C8 ;
        }
      }
      z-index: 999999 !important;
      background: #ffffff;
      margin-bottom: 0;
      position: absolute;
      top: 16px;
      width: 420px;
      height: 170px;
      margin-top: 48px !important;
      border-radius: 10px;
      padding: 20px;
      &::before {
        content: "";
        position: absolute;
        left: 340px;
        top: -10px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
      }
      .el-dialog__header {
        padding: 0;
        .el-dialog__headerbtn {
          display: none;
        }
      }
      .el-dialog__body {
        padding: 0;
        .guide-msg {
          display: flex;
          div {
            flex: 1;
            font-size: 14px;
            .highlight {
              background: #e8efff;
              color: #409eff;
            }
          }
          h2 {
            margin-bottom: 20px;
            font-size: 16px;
            color: #333;
          }
          .vip {
            padding-right: 4px;
            .title {
              margin-bottom: 10px;
            }
          }
          .operation {
            padding-left: 14px;
            border-left: 1px solid #d9d9d9;
          }
        }
      }
      .el-dialog__footer {
        padding: 0;
        .btn {
          display: inline-block;
          margin-right: 30px;
          width: 80px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background: #409eff;
          color: #fff;
          cursor: pointer;
        }
        .el-checkbox__label {
          color: #999;
          font-size: 14px;
        }
        .el-checkbox__inner {
          border-radius: 0;
          height: 18px;
          width: 18px;
          line-height: 18px;
          &::after {
            left: 6px;
            top: 3px;
          }
        }
      }
    }
  }
  .masking {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }
}
</style>
